<template>
  <v-card class="section-block__content">
      <div class="section-title">{{ action.title }}</div>

      <div class="short-description">{{ action.short_description }}</div>

    <div class="actions-buttons">
      <v-btn
        v-if="action.pdf_file_url"
        color="secondary"
        class="w-50"
        @click="$emit('show-pdf', action.pdf_file_url)"
      >Правила конкурса</v-btn>

      <v-btn
        v-if="action.pdf_detail_file_url"
        color="secondary"
        class="w-50"
        @click="$emit('show-pdf', action.pdf_detail_file_url)"
      >Список товаров</v-btn>


      <v-btn
        color="secondary"
        :class="`${(action.pdf_file_url && action.pdf_detail_file_url) ? 'w-100' : 'w-50' }`"
        @click="$emit('show-desc', action.id)"
      >
        Описание
        <font-awesome-icon v-if="expandedId === action.id" icon="chevron-up" class="mr-2 size-18 btn-icon"/>
        <font-awesome-icon v-else icon="chevron-down" class="mr-2 size-18 btn-icon"/>
      </v-btn>

      <div
        v-if="expandedId === action.id && action.description"
        class="w-100"
        v-html="action.description"
      />

      <div v-if="showParticipateBlock" class="w-100">
        <v-btn
          v-if="!action.is_confirmed"
          color="primary"
          class="actions__btn actions__btn--take-part"
          :loading="loadingActionId === action.id"
          :disabled="!!loadingActionId"
          @click="$emit('take-part', action)"
          block
        >
          Участвовать
        </v-btn>
        <v-btn v-else color="primary" class="actions__btn" disabled block>
          Вы участвуете
          <span v-if="action.confirmed_at" class="actions__confirmed-date">
            (с {{ formatConfirmedDate(action.confirmed_at) }})
          </span>
        </v-btn>
      </div>

      <div v-else-if="showParticipationStatus" class="w-100">
        <v-btn color="primary" class="actions__btn" disabled block>
          <template v-if="!action.is_confirmed">
            Вы не участвовали в акции
          </template>
          <template v-else-if="action.confirmed_at">
            Вы участвовали с {{ formatConfirmedDate(action.confirmed_at) }}
          </template>
          <template v-else>
            Вы участвовали в акции
          </template>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import formatDate from '../../../utils/format-date';

export default {
  name: 'ActionCard',
  props: {
    action: { type: Object, required: true },
    showParticipate: { type: Boolean, default: false },
    showParticipationInfo: { type: Boolean, default: false },
    loadingActionId: { type: Number, default: null },
    expandedId: { type: Number, default: null },
  },
  computed: {
    isConsentTracked() {
      return !!this.action.check_participation;
    },
    showParticipateBlock() {
      return this.showParticipate && (this.isConsentTracked || this.action.is_confirmed);
    },
    showParticipationStatus() {
      return this.showParticipationInfo && this.isConsentTracked;
    },
  },
  methods: {
    formatConfirmedDate: formatDate,
  },
};
</script>
